export { ClickAwayListener as default } from '@mui/base/ClickAwayListener';